import { useEffect, useState } from "react";
import Lenis from "lenis";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Philosophy from "@/components/Philosophy";
import Capabilities from "@/components/Capabilities";
import HowCapable from "@/components/HowCapable";
import TodayWorkout from "@/components/TodayWorkout";
import SamplePrograms from "@/components/SamplePrograms";
import Gallery from "@/components/Gallery";
import Stats from "@/components/Stats";
import UpcomingSessions from "@/components/UpcomingSessions";
import Testimonials from "@/components/Testimonials";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import ChooseTrain from "@/components/ChooseTrain";
import WhatsAppButton from "@/components/WhatsApp";

export default function Landing() {
  const [showSticky, setShowSticky] = useState(false);
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const raf = (t) => { lenis.raf(t); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    const obs = new IntersectionObserver(([e]) => setShowSticky(!e.isIntersecting), { rootMargin: "-90px" });
    const cta = document.querySelector('[data-testid="hero-cta-row"]');
    if (cta) obs.observe(cta);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); obs.disconnect(); };
  }, []);

  useEffect(() => {
    api.get("/public/settings").then((r) => setSiteSettings(r.data)).catch(() => setSiteSettings(null));
  }, []);

  const announcement = siteSettings?.announcement || (siteSettings?.maintenance_mode ? "Maintenance mode is enabled. Some booking features may be unavailable." : "");

  return (
    <div className="bg-ink text-white antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      {announcement && (
        <div data-testid="site-announcement" className="fixed top-16 sm:top-20 inset-x-0 z-40 bg-volt text-black text-center text-[10px] uppercase tracking-[0.16em] font-extrabold px-4 py-2">
          {announcement}
        </div>
      )}
      <main>
        <Hero />
        <Marquee />
        <HowCapable />
        <Philosophy />
        <Capabilities />
        <ChooseTrain />
        <TodayWorkout />
        <SamplePrograms />
        <Gallery />
        <Stats />
        <UpcomingSessions />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
      {showSticky && (
        <a href="/assessment" data-testid="sticky-assessment-cta"
          className="sm:hidden fixed bottom-20 left-4 right-4 z-[60] bg-volt text-black text-center uppercase tracking-[0.18em] text-xs font-extrabold px-4 py-4 shadow-lg">
          Take the Assessment →
        </a>
      )}
    </div>
  );
}
